'use client';

import { useEffect } from 'react';

// Lets Playwright (or any test runner) know the client has actually hydrated, not just that the
// server-rendered HTML arrived — a click/fill before this point can silently no-op because React
// hasn't attached its event handlers yet.
const HydrationMarker = () => {
  useEffect(() => {
    document.documentElement.dataset.hydrated = 'true';
  }, []);

  return null;
};

export default HydrationMarker;
